import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import store from '@/store';
import { STORE_CONST } from '@/constants';
import BTB_CONF from '@/btb-conf.json';


export interface IAppState {}

@Module({ namespaced: true, name: STORE_CONST.USER_CONF_MODULE_NAME, store })
export class UserConfModule extends VuexModule implements IAppState {
  playbackRate = 1;
  playbackRates = [0.5, 1, 1.5, 2];
  textTrackSettingsOptions: any = {};
  showCaptions: boolean = false;
  lightMode = true;
  audio = true;
  staticButton = false;
  showVideoTranscript: boolean = false;
  automaticScroll: boolean = true;
  volume: number = 1.0;

  get getLightMode() {
    return this.lightMode;
  }

  get getVolume() {
    return this.volume;
  }

  get getAudio() {
    return this.audio;
  }

  get getStaticButton() {
    return this.staticButton;
  }

  get getShowCaptionsMode() {
    return this.showCaptions ? 'showing' : 'hidden';
  }

  get getShowCaptions() {
    return this.showCaptions;
  }

  get getSpeedRatio(): number {
    return this.playbackRate;
  }

  get getTextTrackSettingsOptions(): any {
    return this.textTrackSettingsOptions;
  }

  get getShowVideoTranscript(): boolean {
    return this.showVideoTranscript;
  }

  get getAutomaticScroll(): boolean {
    return this.automaticScroll;
  }

  @Mutation
  SET_VOLUME(volume: number) {
    this.volume = volume;
  }

  @Mutation
  CHANGE_AUDIO(isOn?: boolean) {
    if (typeof isOn !== 'undefined') {
      return (this.audio = isOn);
    } else {
      this.audio = !this.audio;
    }
  }

  @Mutation
  CHANGE_STATIC_BUTTON() {
    this.staticButton = !this.staticButton;
  }

  @Mutation
  CHANGE_LIGHTMODE() {
    this.lightMode = !this.lightMode;
  }

  @Mutation
  SET_LIGHTMODE(mode: boolean) {
    this.lightMode = mode
  }
  
  @Mutation
  CHANGE_SPEED_RATIO(playbackRate: number) {
    this.playbackRate = playbackRate;
  }

  @Mutation
  CHANGE_CAPTION_SETTINGS(ttso: any) {
    this.textTrackSettingsOptions = ttso;
  }

  @Mutation
  CHANGE_SHOW_CAPTION(show: boolean) {
    this.showCaptions = show;
  }

  @Mutation
  SET_SHOW_VIDEO_TRANSCRIPT(showVideoTranscript: boolean) {
    this.showVideoTranscript = showVideoTranscript;
  }

  @Mutation
  SET_AUTOMATIC_SCROLL(automaticScroll: boolean) {
    this.automaticScroll = automaticScroll;
  }

  @Action({ rawError: true })
  changeStaticButton() {
    this.context.commit('CHANGE_STATIC_BUTTON');
  }

  @Action({ rawError: true })
  changeLightMode() {
    this.context.commit('CHANGE_LIGHTMODE');
  }

  @Action({ rawError: true })
  public setLightMode(mode:boolean) {
    this.context.commit('SET_LIGHTMODE',mode);
  }

  @Action({ rawError: true })
  changeAudio(on?: boolean) {
    this.context.commit('CHANGE_AUDIO', on);
  }

  @Action({ rawError: true })
  public changeSpeedRatio(playbackRate: number) {
    this.context.commit('CHANGE_SPEED_RATIO', playbackRate);
  }

  @Action({ rawError: true })
  public changeTextTrackSettingsOptions(ttso: any) {
    this.context.commit('CHANGE_CAPTION_SETTINGS', ttso);
  }

  @Action({ rawError: true })
  public changeShowCaption(showCaption: boolean) {
    this.context.commit('CHANGE_SHOW_CAPTION', showCaption);
  }

  @Action({ rawError: true })
  public toggleAutoScroll() {
    this.context.commit('SET_AUTOMATIC_SCROLL', !this.getAutomaticScroll);
  }

  @Action({ rawError: true })
  toggleShowVideoTranscript() {
    this.context.commit('SET_SHOW_VIDEO_TRANSCRIPT', !this.showVideoTranscript);
  }

  @Action({ rawError: true })
  setVolume(volume: number) {
    this.context.commit('SET_VOLUME', volume);
  }
}
